import axios from "axios";
class UserDocSuppService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Gustavo Pacheco
   * @description methods to save INE and autograph signature
   * @date 25-06-2021
   * @token {String}
   * @param {Object}
   * @returns {Object}
   * @memberof
   */

  async sendUserDocSupps(token, params) {
    let response = await axios.post(
      `${this.apiUrl}/user-doc-support-signature`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
  async changeUserDocSupps(token, params) {
    let response = await axios.put(
      `${this.apiUrl}/user-doc-support-signature`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async getUserDocSupps(token) {
    let response = await axios.get(
      `${this.apiUrl}/user-doc-support-signature`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  }

  async deleteUserDocSupps(token) {
    let response = await axios.delete(
      `${this.apiUrl}/user-doc-support-signature`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description methods to save INE and autograph signature
   * @date 06-12-2021
   * @token {String}
   * @param {Object}
   * @returns {Object}
   * @memberof
   */
  async getUserDocs(token) {
    let response = await axios.get(
      `${this.apiUrl}/user-doc-support-signature-profile`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Handle event to create the request reliable
   * @date 21-07-2021
   * @param {String} token
   * @param {Object} requestFiles
   * @returns {Object}
   * @memberof UserDocSuppService
   */
  async createRequestReliable(requestFiles, token) {
    let response = await axios.post(
      `${this.apiUrl}/user-doc-support-signature-profile`,
      requestFiles,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data
  }

  /**
  * @author Edgar Escobedo
  * @description GEt info of user signature base by id
  * @date 02-04-2024
  * @param {String} token
  * @param {Object} id
  * @returns {Object}
  * @memberof UserDocSuppService
  */
  async getUserSigantureBaseinfo(id, token){
    let response = await axios.get(
      `${this.apiUrl}/user-signature-base?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}
export { UserDocSuppService as default };
